// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react'
import { DARKER_SAVANT_GREEN } from './utils/constants.ts'

function ExportDateStamp({ width, height }: { width: number; height: number }) {
    const yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1)

    const formattedDate = yesterday.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    })

    return (
        <>
            <text
                x={30}
                y={height - 15}
                textAnchor="start"
                fontSize="11px"
                fill={DARKER_SAVANT_GREEN}
            >
                Slashed bars with no numbers indicate that the player has not
                qualified in that metric.
            </text>
            <text
                x={width - 30}
                y={height - 15}
                textAnchor="end"
                fontSize="11px"
                fill={DARKER_SAVANT_GREEN}
            >
                Data reflects games up to: {formattedDate}
            </text>
        </>
    )
}

export default ExportDateStamp
